/**
 * @license Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
 */

.score-delta-badge {
  height: var(--build-score-delta-badge-height);
  padding: 0 var(--base-spacing);
  border-radius: calc(var(--build-score-delta-badge-height) / 2);
  line-height: var(--build-score-delta-badge-height);

  background: var(--neutral-color);
  color: var(--inverted-text-color);

  font-family: var(--monospace-font-family);
  font-size: var(--monospace-font-size);
  text-align: center;
}

.score-delta-badge.score-delta-badge--improvement {
  background-color: var(--improvement-color);
}

.score-delta-badge.score-delta-badge--regression {
  background-color: var(--regression-color);
}
